import {
  createApi,
  fetchBaseQuery,
  type BaseQueryFn,
} from "@reduxjs/toolkit/query/react";
import type { RootState } from "./store";
import { settingsApiSlice } from "./settingsApi";
import { acquireToken } from "@/helpers";

const dynamicBaseQuery: BaseQueryFn = async (args, api, extraOptions) => {
  const state = api.getState() as RootState;

  const settingsResult = settingsApiSlice.endpoints.getSettings.select()(state);

  if (!settingsResult.data?.apiBaseUrl) {
    return {
      error: {
        status: "CUSTOM_ERROR",
        error:
          "API base URL not available. Please ensure settings are loaded first.",
      },
    };
  }

  if (!settingsResult.data.azureAdClientId) {
    return {
      error: {
        status: "CUSTOM_ERROR",
        error:
          "Azure AD Client ID not available. Please ensure settings are loaded first.",
      },
    };
  }

  if (!settingsResult.data.apiAppIdUri) {
    return {
      error: {
        status: "CUSTOM_ERROR",
        error:
          "API App ID URI not available. Please ensure settings are loaded first.",
      },
    };
  }

  const baseQuery = fetchBaseQuery({
    baseUrl: settingsResult.data.apiBaseUrl,
    prepareHeaders: async (headers) => {
      const token = await acquireToken(
        settingsResult.data!.azureAdClientId,
        settingsResult.data!.apiAppIdUri
      );

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      return headers;
    },
  });

  return baseQuery(args, api, extraOptions);
};

/**
 * Dynamic API Slice.
 * This slice is used to interact with the main server API based on the settings fetched from the settings API.
 * It allows for dynamic base URL configuration based on the settings.
 */
export const dynamicApiSlice = createApi({
  reducerPath: "dynamicApi",
  baseQuery: dynamicBaseQuery,
  endpoints: () => ({}),
  tagTypes: ["WorkflowInstance", "WorkflowStepInstanceThoughts", "AccessControlEntry"],
});
